module.exports = require("@pb/kit-component-pagination");